export default function ParagraphText(props) {
    return <section className="about_intro">
        {props.data}
    </section>


}